import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { updateUserInfo } from "../../store/modules/auth";
import {
  setProfileData,
  setProfileDataLoading,
  updateProfileData,
  setProfileDataError,
} from "../../store/modules/profile";
import { API } from "../endpoints";

export function getUserProfile() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.MY_PROFILE.GET_PROFILE_DETAILS,
        payload: {},
        config: { notifyError: false, loadingFn: setProfileDataLoading },
      })
    );

    if (res.success) {
      await dispatch(setProfileData(res.data));
    } else {
      dispatch(setProfileDataError(res.message));
    }

    return res;
  };
}

export function getProfileById(id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.MY_PROFILE.GET_PROFILE_DETAILS_BY_ID(id),
        payload: {},
        config: { notifyError: true },
      })
    );

    if (res.success) {
    } else {
    }

    return res;
  };
}

export function updateUserProfile(payload, config = {}) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.MY_PROFILE.UPDATE_PROFILE_DETAILS,
        payload,
        config: {
          notifySuccess: false,
          ...config,
        },
      })
    );

    if (res.success) {
      dispatch(updateProfileData(res.data));
    }

    return res;
  };
}

export function createUserProfile(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.MY_PROFILE.UPDATE_PROFILE_DETAILS,
        payload,
        config: {},
      })
    );

    if (res.success) {
      dispatch(
        updateUserInfo({
          profileId: res.data.id,
        })
      );
    }

    return res;
  };
}

export function createDefaultMarketplaceProfile() {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.MY_PROFILE.CREATE_DEFAULT_MARKETPLACE_PROFILE,
        payload: {},
      })
    );

    if (res.success) {
      dispatch(
        updateProfileData({
          marketplaceId: res.data?.marketplaceId,
        })
      );
    }
  };
}

export function finishProfileSetup(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PATCH,
        url: API.MY_PROFILE.FINISH_PROFILE_SETUP,
        payload,
        config: {
          notifySuccess: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function addProfileProductList(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.MY_PROFILE.ADD_PRODUCT_LIST,
        payload,
        config: {
          successMessage: "Profile updated successfully",
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function userTransfeManagementRights(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.MY_PROFILE.TRANSFER_MANAGEMENT_RIGHTS,
        payload,
        config: {
          successMessage:
            "Management rights have been successfully transferred",
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function updateProfileProductList(id, payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.MY_PROFILE.UPDATE_PRODUCT_LIST({ id }),
        payload,
        config: {
          successMessage: "Profile updated successfully",
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function deleteProfileProduct(id) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.DELETE,
        url: API.MY_PROFILE.DELETE_PRODUCT({ id }),
        payload: {},
        config: {
          successMessage: "Profile updated successfully",
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function uploadVendorLogo(data) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PATCH,
        url: API.MY_PROFILE.UPLOAD_VENDOR_LOGO,
        payload: data,
        config: {
          notifyError: true,
          notifySuccess: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function uploadVendorCover(data) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PATCH,
        url: API.MY_PROFILE.UPLOAD_VENDOR_COVER,
        payload: data,
        config: {
          notifyError: true,
          notifySuccess: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function deleteNotifications() {
  return async function (dispatch, getState) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PATCH,
        url: API.MY_PROFILE.CLEAR_NOTIFICATIONS,
        payload: {},
        config: {
          validateUser: true,
          notifySuccess: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}
